import { render, staticRenderFns } from "./MasterList.vue?vue&type=template&id=839088c2&scoped=true&"
import script from "./MasterList.vue?vue&type=script&lang=ts&"
export * from "./MasterList.vue?vue&type=script&lang=ts&"
import style0 from "./MasterList.vue?vue&type=style&index=0&id=839088c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "839088c2",
  null
  
)

export default component.exports